import * as React from 'react';
import type { Slot } from '../../../lib/types';

type NearbySlotProps = {
    slot: Slot;
    onSelect: (time: Slot['time']) => void;
    className?: string;
};

export default function NearbySlot({
    slot: { time, label },
    onSelect,
    className,
}: NearbySlotProps) {
    const handleSelect = React.useCallback(() => {
        onSelect(time);
    }, [time, onSelect]);
    return (
        <button type="button" onClick={handleSelect} className={className}>
            {label}
        </button>
    );
}
